module.exports = __webpack_public_path__ + "static/media/view4.ac6644f5.jpg";